<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="home">
    <!-- HERO -->
    <section class="hero">
      <div class="hero-left">
        <div class="hero-eyebrow">
          <span class="hero-eyebrow-line"></span>
          <span>THE ART OF LIVING GREEN</span>
        </div>
        <h1 class="hero-title">讓植物<em>療癒</em>生活，<br />不再成為負擔</h1>
        <p class="hero-subtitle">
          透過均水導流技術與可替換營養模組，<br />打造低維護、高存活率植栽系統。
        </p>
        <div class="hero-cta">
          <router-link to="/products" class="btn-primary"
            >探索系列植栽</router-link
          >
          <router-link to="/about" class="btn-ghost">品牌故事</router-link>
        </div>
        <div class="hero-stats">
          <div>
            <div class="hero-stat-num">95%</div>
            <div class="hero-stat-label">存活率</div>
          </div>
          <div>
            <div class="hero-stat-num">30+</div>
            <div class="hero-stat-label">植栽品種</div>
          </div>
        </div>
      </div>
      <div class="hero-right">
        <img
          src="@/assets/logo.png"
          alt="綠憩植研 Logo"
          class="hero-img-placeholder"
        />
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-company">
          <p class="footer-company-name">
            綠憩植研科技有限公司 Green Rich Geam
          </p>
          <p class="footer-company-meta">台灣・台北｜負責人：林丕興</p>
        </div>
        <p class="footer-copyright">
          © 2026 綠憩植研 Green Rich Geam. All rights reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<script setup></script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.home {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

/* HERO */
.hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 40px;
}

.hero-eyebrow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  color: #6b7f68;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.hero-eyebrow-line {
  display: inline-block;
  width: 20px;
  height: 1px;
  background: #4e7b4f;
}

.hero-title {
  font-size: 3.5em;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 20px;
  color: #1c2b1a;
}

.hero-title em {
  font-style: normal;
  color: #4e7b4f;
}

.hero-subtitle {
  font-size: 1.1em;
  color: #6b7f68;
  margin-bottom: 40px;
  line-height: 1.8;
}

.hero-cta {
  display: flex;
  gap: 20px;
  margin-bottom: 60px;
}

.btn-primary {
  padding: 14px 32px;
  background: #4e7b4f;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.btn-primary:hover {
  background: #2d5016;
  transform: translateY(-2px);
}

.btn-ghost {
  padding: 14px 32px;
  background: transparent;
  border: 2px solid #4e7b4f;
  color: #4e7b4f;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.btn-ghost:hover {
  background: #4e7b4f;
  color: white;
}

.hero-stats {
  display: flex;
  gap: 40px;
}

.hero-stat-num {
  font-size: 2.5em;
  font-weight: 600;
  color: #4e7b4f;
}

.hero-stat-label {
  font-size: 13px;
  color: #6b7f68;
  margin-top: 4px;
}

.hero-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-img-placeholder {
  width: 100%;
  max-width: 380px;
  height: auto;
  border-radius: 16px;
  object-fit: contain;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

/* FOOTER */
.footer {
  background: #1c2b1a;
  color: #9baa97;
  text-align: center;
  padding: 40px;
  margin-top: 60px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-company {
  margin-bottom: 12px;
}

.footer-company-name {
  font-size: 14px;
  font-weight: 600;
  color: #eaf2e0;
  margin-bottom: 4px;
}

.footer-company-meta {
  font-size: 12px;
  color: #9baa97;
}

.footer-copyright {
  font-size: 12px;
  color: #9baa97;
}

@media (max-width: 768px) {
  .hero {
    grid-template-columns: 1fr;
    gap: 40px;
    margin: 40px auto;
  }

  .hero-title {
    font-size: 2.2em;
  }

  .nav-links {
    gap: 20px;
    font-size: 12px;
  }
}
</style>
